import { Modal, Input, Form, Row, Col, Button } from 'antd'
import React, { useState } from 'react'
import { ButtonEx } from '../../../styles/button.style'
import _, { isNull } from 'lodash'
import { useDeepEffect } from '../../../utils/hooks'

const UpdateDetail = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { setFieldsValue, getFieldDecorator, validateFields } = form

  useDeepEffect(() => {
    if (!_.isEmpty(formData)) {
      setFieldsValue({
        detail: formData.detail,
      })
    }
    return () => {
      form.resetFields()
    }
  }, [formData])

  const onSubmit = (e) => {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          detail: values.detail
        }
        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }
        onOk(data)
      }
    })
  }

  return (
    <Modal
      width={600}
      title="Update Detail"
      visible={visible}
      onCancel={onCancel}
      footer={null}
    >
      <Form onSubmit={onSubmit}>
        <Form.Item>
          {getFieldDecorator(`detail`, {
          })(
            <Input.TextArea autoSize={{ minRows: 5 }} />)}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>Cancel</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              Update
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedUpdateDetail = Form.create({
  name: 'UpdateDetail'
})(UpdateDetail)
export default (WrappedUpdateDetail)
